const handleSendNewPassword = require("./handleSendNewPassword");
const handleSendResetPasswordEmail = require("./handleSendResetPasswordEmail");
const forgotPasswordSetupRequest = require("./forgotPasswordSetupRequest");
const setNewPasswordSetupRequest = require("./setNewPasswordSetupRequest");
const sendResetPasswordEmail = require("./sendResetPasswordEmail");
const sendNewPassword = require("./sendNewPassword");

module.exports = {
  handleSendNewPassword,
  handleSendResetPasswordEmail,
  forgotPasswordSetupRequest,
  setNewPasswordSetupRequest,
  sendResetPasswordEmail,
  sendNewPassword,
};
